<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-2" justified>
        <b-tab active title="Page">
          <CareerOpportunities />
        </b-tab>
        <b-tab title="Banner">
          <b-card-text>
            <Banner />
          </b-card-text>
        </b-tab>
        <b-tab title="Life at Cit">
          <b-card-text>
            <Lifecit />
          </b-card-text>
        </b-tab>
        <b-tab title="Facilities">
          <b-card-text>
            <Facilities />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { BTabs, BTab, BCard, BCardText } from "bootstrap-vue";
import Banner from "./partials/Banner.vue";
import CareerOpportunities from "./partials/CareerOpportunities.vue";
import Lifecit from "./partials/LifeCit.vue";
import Facilities from "./partials/Facilities.vue";

export default {
  components: {
    Banner,
    CareerOpportunities,
    BCard,
    BCardText,
    BTabs,
    BTab,
    Lifecit,
    Facilities
  },
};
</script>

<style></style>
